import React, { Component } from 'react';
import {
    Typography,
    Box,
    Card,
    TextField,
    withStyles
} from '@material-ui/core';
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";
import CustomButton from "../../shared/components/common/customButton";
import { withRouter } from "react-router-dom";

const styles = theme => ({
    root: {
        padding: '0 calc(1.5rem * .5)',
        margin: '1.5rem auto 0 auto',
        color: '#ffffff',
        maxWidth: '960px',
    },
    searchContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1rem',
        marginBottom: '1.5rem',
    },
    searchField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '50rem',
            backgroundColor: '#f5f5f5',
            '& fieldset': {
                borderRadius: '50rem',
                border: '1px solid #dee2e6',
                transition: 'border-color .15s ease-in-out, box-shadow .15s ease-in-out',
            },
            '&:hover fieldset': {
                border: '1px solid #dee2e6',
            },
            '&.Mui-focused fieldset': {
                border: '1px solid #86b7fe',
                boxShadow: '0 0 0 0.25rem rgba(13, 110, 253, 0.25)',
            },
        },
        '& .MuiInputBase-input': {
            fontWeight: 500,
            color: '#212529',
            padding: '12px 20px',
        },
    },
    cardSection: {
        background: 'linear-gradient(to right, #3e526d, #1F2937)',
        borderRadius: '6px',
        boxShadow: '3px 3px 5px rgba(0, 0, 0, 0.76);',
        border: '1px solid #E9ECEF',
        color: '#FFFFFF',
        marginBottom: '1.5rem',
        padding: '1rem',
        animation: '$fadeInUp 0.5s ease-out',
    },
    messageContainer: {
        marginTop: '3rem',
        textAlign: 'center',
        fontSize: 'calc(1.275rem + .3vw)',
        fontWeight: 500,
        color: '#212529',
    },
    cardRow: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '10px',
        marginBottom: '4px',
        backgroundColor: '#257b79',
        borderRadius: '8px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
        '&:hover': {
            backgroundColor: '#ffffff4d',
        },
    },
    cardRowOrcamento: {
        backgroundColor: '#824291',
        '&:hover': {
            backgroundColor: '#ffffff4d',
        },
    },
    cardText: {
        fontSize: '1rem',
        fontWeight: 400,
        color: '#FFFFFF',
    },
    rowItemSm: {
        flex: '1 1 100px',
    },
    rowItemMd: {
        flex: '1 1 150px',
    },
    rowItemLg: {
        flex: '1 1 200px',
    },
    rowItemXl: {
        flex: '2 1 200px',
    },
    sectionTitle: {
        color: '#ffffff',
        marginBottom: theme.spacing(2),
    },
    '@keyframes fadeInUp': {
        from: {
            opacity: 0,
            transform: 'translateY(200px)',
        },
        to: {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
});

class AdminSearchPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            empresaCnpj: '',
            cotacao: '',
            empresas: [],
            cotacoes: [],
            mostrarEmpresas: false,
            mostrarCotacoes: false,
            mostrarMensagemInicial: true
        };
    }

    componentDidMount() {
        this.initBuscar();
    }

    componentWillUnmount() {
        this.cleanupBuscar();
    }

    mockEmpresas = [
        {
            id: 1,
            empresa: 'Empresa Teste Ltda',
            email: 'contato@empresa.com',
            fone: '(11) 99999-9999',
            cnpj: '12.345.678/0001-90'
        },
        {
            id: 2,
            empresa: 'Indústria Exemplo SA',
            email: 'vendas@exemplo.com',
            fone: '(11) 88888-8888',
            cnpj: '98.765.432/0001-10'
        },
        {
            id: 3,
            empresa: 'Comércio Modelo ME',
            email: 'atendimento@modelo.com',
            fone: '(11) 77777-7777',
            cnpj: '11.222.333/0001-44'
        }
    ];

    mockCotacoes = [
        {
            id: 1001,
            tipo: 'estimativa',
            empresa: 'Empresa Teste Ltda',
            data: '15/01/2024',
            valor: 1500.00
        },
        {
            id: 1002,
            tipo: 'orcamento',
            empresa: 'Indústria Exemplo SA',
            data: '16/01/2024',
            valor: 2500.00
        },
        {
            id: 1003,
            tipo: 'pedido',
            empresa: 'Comércio Modelo ME',
            data: '17/01/2024',
            valor: 3200.00
        }
    ];

    initBuscar = () => {
        // Inicialização se necessário
    };

    cleanupBuscar = () => {
        this.setState({
            empresas: [],
            cotacoes: [],
            mostrarEmpresas: false,
            mostrarCotacoes: false,
            mostrarMensagemInicial: true,
            empresaCnpj: '',
            cotacao: ''
        });
    };

    handleEmpresaCnpjChange = (event) => {
        const value = event.target.value;
        this.setState({ empresaCnpj: value }, () => {
            if (value.trim()) {
                this.buscarDados('empresa-cnpj');
            } else {
                this.cleanupBuscar();
            }
        });
    };

    handleCotacaoChange = (event) => {
        const value = event.target.value;
        this.setState({ cotacao: value }, () => {
            if (value.trim()) {
                this.buscarDados('cotacao');
            } else {
                this.cleanupBuscar();
            }
        });
    };

    buscarDados = async (tipoBusca) => {
        let termo = '';
        let tipo = tipoBusca;

        if (tipoBusca === 'empresa-cnpj') {
            termo = this.state.empresaCnpj.trim();
            if (!termo) return;

            const isNumero = /^\d+$/.test(termo);
            tipo = isNumero ? 'cnpj' : 'empresa';

        } else if (tipoBusca === 'cotacao') {
            termo = this.state.cotacao.trim();
            if (!termo) return;
        }

        try {
            let dados;

            if (tipo === 'empresa' || tipo === 'cnpj') {
                dados = this.mockEmpresas.filter(empresa =>
                    empresa.empresa.toLowerCase().includes(termo.toLowerCase()) ||
                    empresa.cnpj.includes(termo)
                );
            } else {
                dados = this.mockCotacoes.filter(cotacao =>
                    cotacao.id.toString().includes(termo)
                );
            }

            this.setState({
                mostrarMensagemInicial: false,
                mostrarEmpresas: false,
                mostrarCotacoes: false
            });

            if ((tipo === 'empresa' || tipo === 'cnpj') && dados.length) {
                this.setState({
                    empresas: dados,
                    mostrarEmpresas: true
                });
            } else if (tipo === 'cotacao' && dados.length) {
                this.setState({
                    cotacoes: dados,
                    mostrarCotacoes: true
                });
            }

        } catch (error) {
            console.error('Erro na busca:', error);
        }
    };

    // carregarListaCotacoes = (clienteId, empresaNome) => {
    //     const { history } = this.props;
    //     history.push(`/bepi/admin/quotations?userId=${clienteId}&empresa=${encodeURIComponent(empresaNome)}`);
    // };

    carregarDetalhes = (tipo, id) => {
        const { history } = this.props;
        const { cotacoes } = this.state;

        const cotacaoSelecionada = cotacoes.find(cotacao => String(cotacao.id) === String(id));

        if (cotacaoSelecionada) {
            localStorage.setItem('cotacaoSelecionada', JSON.stringify({
                ...cotacaoSelecionada,
                cliente: cotacaoSelecionada.empresa
            }));
            localStorage.setItem('clienteInfo', JSON.stringify({ nome: cotacaoSelecionada.empresa, user_id: null }));
        }

        history.push(`/bepi/admin/quote/details?id=${id}`);
    };

    renderMensagemInicial = () => {
        const { mostrarMensagemInicial } = this.state;
        const { classes } = this.props;
        const { currentLanguage } = this.props;

        if (!mostrarMensagemInicial) return null;

        return (
            <Typography className={classes.messageContainer}>
                {currentLanguage.bepiService.admin.admin_search_msg_initial}
            </Typography>
        );
    };

    renderEmpresas = () => {
        const { empresas, mostrarEmpresas } = this.state;
        const { classes } = this.props;
        const { currentLanguage } = this.props;

        if (!mostrarEmpresas) return null;

        return (
            <Card className={classes.cardSection}>
                <Typography variant="h5" className={classes.sectionTitle}>
                    {currentLanguage.bepiService.admin.admin_search_title_companies_found}
                </Typography>

                {empresas.length === 0 ? (
                    <Typography align="center">{currentLanguage.bepiService.admin.admin_search_msg_no_companies}</Typography>
                ) : (
                    <Box>
                        {empresas.map(empresa => (
                            <Box
                                key={empresa.id}
                                className={classes.cardRow}
                            >
                                <Box className={classes.rowItemXl}>
                                    <Typography className={classes.cardText}>
                                        <strong>{currentLanguage.bepiService.admin.admin_search_label_company}</strong>
                                        <br />
                                        {empresa.empresa}
                                    </Typography>
                                </Box>

                                <Box className={classes.rowItemXl}>
                                    <Typography className={classes.cardText}>
                                        <strong>{currentLanguage.bepiService.admin.admin_search_label_email}</strong>
                                        <br />
                                        {empresa.email}
                                    </Typography>
                                </Box>

                                <Box className={classes.rowItemMd}>
                                    <Typography className={classes.cardText}>
                                        <strong>{currentLanguage.bepiService.admin.admin_search_label_phone}</strong>
                                        <br />
                                        {empresa.fone}
                                    </Typography>
                                </Box>

                                <Box className={classes.rowItemMd}>
                                    <Typography className={classes.cardText}>
                                        <strong>{currentLanguage.bepiService.admin.admin_search_label_cnpj}</strong>
                                        <br />
                                        {empresa.cnpj}
                                    </Typography>
                                </Box>

                                {/*<Box className={classes.rowItemLg}>*/}
                                {/*    <CustomButton*/}
                                {/*        variant="blackFilled"*/}
                                {/*        onClick={() => this.carregarListaCotacoes(empresa.id, empresa.empresa)}*/}
                                {/*    >*/}
                                {/*        {currentLanguage.bepiService.admin.admin_search_btn_view_equipments}*/}
                                {/*    </CustomButton>*/}
                                {/*</Box>*/}
                            </Box>
                        ))}
                    </Box>
                )}
            </Card>
        );
    };

    renderCotacoes = () => {
        const { cotacoes, mostrarCotacoes } = this.state;
        const { classes } = this.props;
        const { currentLanguage } = this.props;

        if (!mostrarCotacoes) return null;

        return (
            <Card className={classes.cardSection}>
                <Typography variant="h5" className={classes.sectionTitle}>
                    {currentLanguage.bepiService.admin.admin_search_title_quotations_found}
                </Typography>

                {cotacoes.length === 0 ? (
                    <Typography align="center">{currentLanguage.bepiService.admin.admin_search_msg_no_quotations}</Typography>
                ) : (
                    <Box>
                        {cotacoes.map(cotacao => (
                            <Box
                                key={cotacao.id}
                                className={`${classes.cardRow} ${cotacao.tipo === 'orcamento' || cotacao.tipo === 'pedido'
                                    ? classes.cardRowOrcamento
                                    : ''
                                    }`}
                            >
                                <Box className={classes.rowItemSm}>
                                    <Typography className={classes.cardText}>
                                        <strong>{currentLanguage.bepiService.admin.admin_search_label_doc_num}</strong>
                                        <br />
                                        {cotacao.id}
                                    </Typography>
                                </Box>

                                <Box className={classes.rowItemSm}>
                                    <Typography className={classes.cardText}>
                                        <strong>{currentLanguage.bepiService.admin.admin_search_label_type}</strong>
                                        <br />
                                        {cotacao.tipo}
                                    </Typography>
                                </Box>

                                <Box className={classes.rowItemXl}>
                                    <Typography className={classes.cardText}>
                                        <strong>{currentLanguage.bepiService.admin.admin_search_label_company}</strong>
                                        <br />
                                        {cotacao.empresa}
                                    </Typography>
                                </Box>

                                <Box className={classes.rowItemSm}>
                                    <Typography className={classes.cardText}>
                                        <strong>{currentLanguage.bepiService.admin.admin_search_label_date}</strong>
                                        <br />
                                        {cotacao.data}
                                    </Typography>
                                </Box>

                                <Box className={classes.rowItemLg}>
                                    <CustomButton
                                        variant="blackFilled"
                                        onClick={() => this.carregarDetalhes(cotacao.tipo, cotacao.id)}
                                    >
                                        {currentLanguage.bepiService.admin.admin_search_btn_view}
                                    </CustomButton>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                )}
            </Card>
        );
    };

    render() {
        const { classes } = this.props;
        const { empresaCnpj, cotacao } = this.state;
        const { currentLanguage } = this.props
        const breadcrumbItems = [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/admin' },
            { label: currentLanguage.bepiService.admin.admin_breadcrumb_search },
        ];


        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.admin.admin_breadcrumb_search}
                breadcrumbItems={breadcrumbItems}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.root}>
                    <Box className={classes.searchContainer}>
                        {/* DESATIVADO - Campo Empresa/CNPJ
                        <TextField
                            className={classes.searchField}
                            placeholder={currentLanguage.bepiService.admin.admin_search_placeholder_company_cnpj}
                            value={empresaCnpj}
                            onChange={this.handleEmpresaCnpjChange}
                            style={{ flex: 1 }}
                            variant="outlined"
                        />
                        */}
                        <TextField
                            className={classes.searchField}
                            placeholder={currentLanguage.bepiService.admin.admin_search_placeholder_quotation_num}
                            value={cotacao}
                            onChange={this.handleCotacaoChange}
                            type="number"
                            style={{ minWidth: '200px', flex: 1 }}
                            variant="outlined"
                        />
                    </Box>

                    {this.renderMensagemInicial()}
                    {this.renderEmpresas()}
                    {this.renderCotacoes()}
                </Box>
            </BreadcrumbLayout>
        );
    }
}

export default withRouter(withStyles(styles)(AdminSearchPage));
